import { render, staticRenderFns } from "./parkingArea.vue?vue&type=template&id=6c1f25d4&scoped=true&"
import script from "./parkingArea.vue?vue&type=script&lang=js&"
export * from "./parkingArea.vue?vue&type=script&lang=js&"
import style0 from "./parkingArea.vue?vue&type=style&index=0&id=6c1f25d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f25d4",
  null
  
)

export default component.exports